import styled from 'styled-components';
import { LocalizedButton } from 'shared/ui/localized-button';

export const StyledSignInButton = styled(LocalizedButton)`
    text-transform: uppercase;
`;
